import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Form, Field } from "react-final-form";
import LockOutlineIcon from "mdi-react/LockOutlineIcon";
import EmailOutlineIcon from "mdi-react/EmailOutlineIcon";
import { useDispatch, sendFlashMessage } from "@/shared/components/flash";
import { CodeTwoTone } from "@material-ui/icons";
const IncentcoLogo = `${process.env.PUBLIC_URL}/img/logo-sm.png`;

function Invitation() {
  const [loading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const urlSearch = new URLSearchParams(location.search);
    const serachEmail = urlSearch.get("email");
    if (serachEmail) {
      setEmail(serachEmail);
    }
  }, [location]);

  const handleResend2faCode = async (value) => {
    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i.test(value)) {
      dispatch(sendFlashMessage("Email is not valid", "alert-danger", "top"));
      return;
    }
    setIsLoading(true);
    const data = {
      email: value,
    };
    const endPoint = `/generate-2fa-secret/fasteezy`;
    await axios
      .post(endPoint, data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            sendFlashMessage(response.data.message, "alert-success", "top")
          );
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        dispatch(
          sendFlashMessage(
            err.response.data.message ||
              err?.response?.data?.errors ||
              err?.response.data?.errors?.email[0],
            "alert-danger",
            "top"
          )
        );
      });
  };

  const sendAgain = () => {
    handleResend2faCode(email);
  };

  const validate = (values) => {
    let errors = {};
    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }
    if (!values.password) {
      errors.password = "Password is required";
    }
    if (!values.code) {
      errors.code = "Code is required";
    }
    if (!values.password_confirmation) {
      errors.password_confirmation = "Confrim password is required";
    }
    if (values.password !== values.password_confirmation) {
      errors.password_confirmation = "Passwords must match";
    }
    return errors;
  };

  const onSubmit = async (values) => {
    setIsLoading(true);
    const endPoint = `/invitation/accept/fasteezy`;
    const data = { email, ...values };
    await axios
      .post(endPoint, data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            sendFlashMessage(response.data.message, "alert-success", "top")
          );
          window.location = "/login";
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        dispatch(
          sendFlashMessage(
            err.response.data.message || err.response.data.error,
            "alert-danger",
            "top"
          )
        );
      });
  };

  return (
    <>
      <div className="account flex-column align-items-center pt-4">
        <img src={IncentcoLogo} className="img__logo_sm" alt="logo" />
        <div className="account__wrapper mt-0">
          <div className="account__card">
            <div className="account__head">
              <h3 className="account__title">Set Password</h3>
            </div>

            <div className="login-panel">
              <div className="login-body">
                <Form
                  onSubmit={onSubmit}
                  validate={validate}
                  initialValues={{ email: email }}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                  }) => (
                    <form className="form" onSubmit={handleSubmit}>
                      <>
                        <Field name="email">
                          {({ input, meta }) => (
                            <div className="form__form-group">
                              <span className="form__form-group-label">
                                Email
                              </span>
                              <div className="form__form-group-field">
                                <div className="form__form-group-icon">
                                  <EmailOutlineIcon />
                                </div>
                                <div className="form__form-group-row">
                                  <input
                                    type="text"
                                    {...input}
                                    placeholder="Email"
                                  />
                                  {meta.touched && meta.error && (
                                    <span className="form__form-group-error">
                                      {meta.error}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                        <Field name="code">
                          {({ input, meta }) => (
                            <div className="form__form-group">
                              <span className="form__form-group-label">
                                Verification Code
                              </span>
                              <div className="form__form-group-field">
                                <div className="form__form-group-icon">
                                  <CodeTwoTone />
                                </div>
                                <div className="d-flex">
                                  <input
                                    type="text"
                                    {...input}
                                    placeholder="verification code"
                                  />{" "}
                                  <a
                                    className="fw-500"
                                    style={{
                                      cursor: "pointer",
                                      textAlign: "center",
                                      marginTop: "8px",
                                      width: "150px",
                                    }}
                                    onClick={() => sendAgain()}
                                    disabled={loading}
                                  >
                                    Resend Code
                                  </a>
                                </div>
                              </div>
                              {meta.touched && meta.error && (
                                <span className="form__form-group-error">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="password">
                          {({ input, meta }) => (
                            <div className="form__form-group">
                              <span className="form__form-group-label">
                                Password
                              </span>
                              <div className="form__form-group-field">
                                <div className="form__form-group-icon">
                                  <LockOutlineIcon />
                                </div>
                                <div className="form__form-group-row">
                                  <input
                                    type="password"
                                    {...input}
                                    placeholder="Password"
                                  />
                                </div>
                              </div>
                              {meta.touched && meta.error && (
                                <span className="form__form-group-error">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="password_confirmation">
                          {({ input, meta }) => (
                            <div className="form__form-group">
                              <span className="form__form-group-label">
                                Confirm Password
                              </span>
                              <div className="form__form-group-field">
                                <div className="form__form-group-icon">
                                  <LockOutlineIcon />
                                </div>
                                <div className="form__form-group-row">
                                  <input
                                    type="password"
                                    {...input}
                                    placeholder="Confirm Password"
                                  />
                                </div>
                              </div>
                              {meta.touched && meta.error && (
                                <span className="form__form-group-error">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          )}
                        </Field>
                      </>
                      <button
                        type="submit"
                        className="btn btn-primary account__btn account__btn--small"
                        disabled={loading}
                      >
                        Set Password
                      </button>
                    </form>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Invitation;
